import axios from '../api/BaseURL'
import authHeader from './auth-header'

class invoiceAPI {
  // service_type type create
  invoiceList() {
    return axios.get('/billing/list', { headers: authHeader() })
  }
  // details
  getDetails(id) {
    return axios.get('/billing/details/' + id, { headers: authHeader() })
  }

  getMushokFileDirect(url) {
    return axios.get(url, { headers: authHeader() })
  }

  getMushokFileDirectOpen(fileName = "test.pdf") {
    return axios.get("/billing/serve_file_name/" + fileName, { headers: authHeader() })
  }

  getDetailsList(ids= []) {
    return axios.post('/billing/details-list-data', {"id" : ids}, { headers: authHeader() })
  }


  // list
  getPaidList() {
    return axios.get('/billing/paid-invoice-list', { headers: authHeader() })
  }
  // list
  getUnpaidList() {
    return axios.get('/billing/unpaid-invoice-list', { headers: authHeader() })
  }
  // service_type type update

  // service_type type delete
  deleteInvoice(id) {
    return axios.delete('/billing/delete', {
      headers: authHeader(),
      data: {
        id: id,
      },
    })
  }

  // manual invoice generate
  generateManualInvoice(data) {
    return axios.post('/billing/manual-billing', data, {
      headers: authHeader(),
    })
  }

  // payment recieve
  paymentRecieve(data) {

    if (data.invoice_id === -1) { // advance payment 

      console.log(data.invoice_id);
      console.log(data);
      return axios.post('/billing/advance-payment-receive', data, {
        headers: authHeader(),
      })
    } else {
      return axios.post('/billing/payment-receive', data, {
        headers: authHeader(),
      })
    }
    
  }

  advancePaymentReceive(data) {
    return axios.post('/billing/advance-payment-receive', data, {
      headers: authHeader(),
    })
  }

  // payment recieve
  searchInvoice(data) {
    return axios.post('/billing/search-invoice', data, {
      headers: authHeader(),
    })
  }
  searchInvoiceDistrict(data) {
    return axios.post('/billing/search-invoice-with-district', data, {
      headers: authHeader(),
    })
  }
}
export default new invoiceAPI()
